import { OVERRIDABLE_PROPERTIES_CONFIG, SECTION_ORDER } from '../SyncUpdatesModal.constants';
import { PropertyChangeItem } from '../SyncUpdatesModal.types';

const PROPERTY_ORDER = Object.keys(OVERRIDABLE_PROPERTIES_CONFIG);

const buildGroups = (grouped: Map<string, PropertyChangeItem[]>) =>
  Array.from(grouped.values())
    .map((items) => ({
      section: items[0].section,
      groupType: items[0].groupType as string,
      items: items.slice().sort(
        (a, b) => PROPERTY_ORDER.indexOf(a.propertyName) - PROPERTY_ORDER.indexOf(b.propertyName),
      ),
    }))
    .sort((a, b) => {
      const ai = SECTION_ORDER.indexOf(a.section);
      const bi = SECTION_ORDER.indexOf(b.section);
      const sectionDiff = (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      if (sectionDiff !== 0) return sectionDiff;
      return PROPERTY_ORDER.indexOf(a.items[0].propertyName) - PROPERTY_ORDER.indexOf(b.items[0].propertyName);
    });

export const groupChanges = (changes: PropertyChangeItem[]) => {
  const rootCountByGroupType = new Map<string, number>();
  changes.forEach((item) => {
    if (item.groupType && item.isRoot) {
      const gt = item.groupType as string;
      rootCountByGroupType.set(gt, (rootCountByGroupType.get(gt) ?? 0) + 1);
    }
  });

  const grouped = new Map<string, PropertyChangeItem[]>();
  changes.forEach((item) => {
    const hasMultipleRoots = !!(item.isRoot && item.groupType && (rootCountByGroupType.get(item.groupType as string) ?? 0) > 1);
    const key = (item.groupType && !hasMultipleRoots) ? (item.groupType as string) : item.propertyName;
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key)!.push(item);
  });

  return buildGroups(grouped);
};

export const groupChangesForConfirm = (changes: PropertyChangeItem[]) => {
  const grouped = new Map<string, PropertyChangeItem[]>();
  changes.forEach((item) => {
    if (!grouped.has(item.section)) grouped.set(item.section, []);
    grouped.get(item.section)!.push(item);
  });

  return buildGroups(grouped);
};
